var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_3",
    "data-name": "Download 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 102.598,
    height: 150,
    viewBox: "0 0 102.598 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1675.875-25.558H1741.6v1.749q0,12.2,0,24.4c0,6.652,4.39,11.016,11.066,11.017q11.957,0,23.914,0h1.893v89.348h-9.281c2.262-14.761-1.7-27.5-12.511-37.807a41.533,41.533,0,0,0-31.425-11.678c-25.143,1.03-44.859,23.242-40.263,49.5h-9.118Z",
    transform: "translate(-1675.875 25.558)",
    fill: "#BC8B20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1799.347,279.595c0,13.806-11.361,26.89-26.271,29.471-14.968,2.592-29.276-5.125-35.234-17.647-8.179-17.192,1.327-37.762,19.835-42.982,15.341-4.326,31.051,2.182,38.258,15.879A30.635,30.635,0,0,1,1799.347,279.595Zm-49.935,6.394c4.464,4.69,8.8,9.262,13.156,13.82,2.8,2.931,5.821,2.967,8.6.074q6.388-6.656,12.728-13.359c.287-.3.533-.644.89-1.08l-7.443-7.066-4.853,4.717V254.009h-10.506v29.733l-5.064-4.872Z",
    transform: "translate(-1715.941 -159.566)",
    fill: "#BC8B20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1913.473-20.241l24.413,24.854c-.7.066-1.108.136-1.511.136-7.164.007-14.328-.007-21.491.019-1,0-1.6-.113-1.589-1.353.043-7.538.023-15.076.03-22.614C1913.324-19.407,1913.381-19.615,1913.473-20.241Z",
    transform: "translate(-1837.067 21.948)",
    fill: "#BC8B20"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload3);
export default __webpack_public_path__ + "static/media/Download 3.adcf9213a7df3cd56d990841b743f2f5.svg";
export { ForwardRef as ReactComponent };